import React from 'react';
import { createPortal } from 'react-dom';
import toast from 'react-hot-toast';
import { XCircle } from 'lucide-react';

/**
 * Displays a checkout error genuinely centered in the viewport.
 * Uses a React Portal to break out of the react-hot-toast layout flow.
 */
export function showCenteredCheckoutError(errorMessage: string) {
    toast.custom((t) => createPortal(
        <div className="fixed inset-0 z-[9999] flex items-center justify-center pointer-events-none p-4">
            <div 
                className={`${
                    t.visible ? 'animate-enter' : 'animate-leave'
                } pointer-events-auto flex items-center gap-3 bg-white dark:bg-slate-900 border border-red-200 dark:border-red-900 shadow-2xl rounded-lg p-4 max-w-sm w-full`}
            >
                <XCircle className="w-6 h-6 text-red-500 shrink-0" />
                <span className="text-slate-900 dark:text-slate-100 text-sm font-semibold">{errorMessage}</span>
            </div>
        </div>,
        document.body
    ), { 
        duration: 5000,
        id: `checkout-error-${Date.now()}`
    });
}
